import { Dropdown, Menu } from "antd";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect } from "react";
import Logo from "../assets/icons/logo.svg";
import { auth, db } from "../firebase";
import { SET_BATONS } from "../state/Constants";
import { useStateValue } from "../state/StateProvider";
import ProfileIcon from "../assets/icons/profile.svg";
import DownArrow from "../assets/icons/downArrow.svg";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Header.sass";

const Header = () => {
	const [{ user, batons }, action] = useStateValue();
	const navigate = useNavigate();

	useEffect(() => {
		const getBatons = async () => {
			let q = query(
				collection(db, "batons"),
				where("editAccess", "array-contains", user._id)
			);
			let querySnapshot = await getDocs(q);
			const writeBatons = querySnapshot.docs.map((doc) => {
				return { _id: doc.id, ...doc.data() };
			});
			q = query(
				collection(db, "batons"),
				where("readAccess", "array-contains", user._id)
			);
			querySnapshot = await getDocs(q);
			const readBatons = querySnapshot.docs.map((doc) => {
				return { _id: doc.id, ...doc.data() };
			});
			action({
				type: SET_BATONS,
				payload: { batons: [...writeBatons, ...readBatons] },
			});
		};
		user && getBatons();
	}, [user, action]);

	const handleLogout = () => {
		auth.signOut();
		navigate("/login");
	};

	console.log(user);

	return (
		<div className='flex justify-between items-center px-6 py-1 header fixed w-full h-[50px] z-50 bg-white'>
			<Link to={user ? "/batons" : "/"}>
				<div className='flex gap-1 items-center'>
					<img className='w-5' src={Logo} alt='baton-logo' />
					<h1 className='logo_text text-black'>Baton</h1>
				</div>
			</Link>
			<div className='flex gap-6 items-center'>
				{user && !user?.plan && (
					<div className='px-6 py-2 bg-blue-50 flex gap-14 text-primary rounded'>
						<span>
							You have{" "}
							{3 - batons.filter((b) => b.createdBy._id === user._id).length}{" "}
							batons left.{" "}
						</span>
						<Link to='/settings/subscriptions' className='underline font-bold'>
							Upgrade now
						</Link>
					</div>
				)}
				{user && (
					<div>
						<Dropdown
							overlay={
								<Menu
									items={[
										{
											key: "1",
											label: "Profile",
											icon: <UserOutlined />,
											onClick: () => navigate("/settings/my-account"),
										},
										{
											key: "2",
											danger: true,
											label: "Logout",
											onClick: handleLogout,
											icon: <LogoutOutlined color='red' />,
										},
									]}
								/>
							}
							placement='bottom'
						>
							<div className='flex gap-3 cursor-pointer px-2 mr-2'>
								<span className='font-semibold'>
									{auth?.currentUser?.displayName || "Hi, user"}
								</span>
								<img src={ProfileIcon} alt='Profile avatar' />
								<img src={DownArrow} alt='Arrow' />
							</div>
						</Dropdown>
					</div>
				)}
			</div>
		</div>
	);
};

export default Header;
